<script lang="ts" setup>
const { createEvent } = useAnalytics()
const billingStore = useBillingStore()

onMounted(() => {
  createEvent({ name: '[Navigation] Visit Settings Subscription' })
})
</script>

<template>
  <SubscriptionSummary class="mb-10" />

  <template v-if="billingStore.subscriptionName === 'free'">
    <SubscriptionPlans class="mb-10 md:mb-20" />

    <ProductTrophies />

    <UDivider class="my-12 md:my-16" />
  </template>

  <template v-if="billingStore.subscriptionName === 'free'">
    <SectionFaq />
  </template>
</template>
